<template>
  <div class="projectcard-container" @click="gotoProjectDetails()">
    <div class="picture" :style="{ backgroundImage: 'url(' + pictureURL + ')' }"></div>
    <div class="content">
      <div class="name">{{ project.name }}</div>
      <div class="created">Created {{ new Date(project.created).toLocaleDateString() }}</div>
      <!-- <div class="status">
        <div class="status-dot" :class="dotColor"></div> Status: {{ projectStatus }}
      </div> -->
    </div>
  </div>
</template>

<script>
import { URLify } from '@/utils/urlify.js'
export default {
  name: 'ProjectCard',
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      key: "value"
    }
  },
  methods: {
    gotoProjectDetails() {
      this.$router.push('/project/details/'+ URLify(this.project.name))
    }
  },
  computed: {
    projectStatus() {
      return 'Open'
    },
    dotColor() {
      return this.projectStatus == 'Open' ? 'green-bg' : 'red-bg'
    },
    pictureURL() {
      if(this.project.accessURLs && this.project.accessURLs.length > 0) {
        return this.project.accessURLs.slice().sort((a, b) => a.name > b.name ? 1 : -1)[0].url
      }
      return 'https://storage.googleapis.com/simply-studio-pub-01/stock_project_background.png'
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.projectcard-container {
  box-shadow: 2px 2px 5px rgba(black, 0.2);
  cursor: pointer;
  transition: 0.2s all;

  &:hover {
    box-shadow: 2px 2px 10px rgba(black, 0.4);
  }
}

.picture {
  height: 300px;
  background-color: lightblue;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center; 
}
.content {
  text-align: left;
  padding: 20px;
  padding-bottom: 12px;

  .name {
    font-weight: bold;
    margin-bottom: 8px;
  }

  .created {
    color: $secondaryText;
    font-size: 12px;
  }

  .status {
    font-size: 12px;
    margin-top: 10px;

    .status-dot {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      display: inline-block;
      margin-right: 8px;
    }
  }
}

</style>